import EfImg from 'elem/ui/ef-img';
import EfSpec from 'elem/ui/ef-spec';
import EfTitle from 'elem/ui/ef-title';
import { FC } from 'react';
import css from './index.module.scss';
import { useLang } from '@/i18n';

const TheComp: FC = () => {
    const { t } = useLang('dp3.landing.EU8');
    const cards = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724297402396/sl_ps.png',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724297402200/sl_w2.png',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724297402030/sl_g.png',
        },
    ];

    return (
        <div
            id="dp3-teaser-EU8"
            className={`${css.thecomp} dp3-teaser-EU8 dp3-teaser-full GtmModuleData-section`}
            data-section-id={'dp3-EU8'}
            data-section-title={t('title')}
        >
            <EfSpec className="spec-x" />
            <EfTitle className="title" hasAnimation={false}>
                {t('title')}
            </EfTitle>
            <div className="cards-box">
                <EfImg
                    pc="https://websiteoss.ecoflow.com/upload/image/1724987290418/pc-compatible-kv.png"
                    pad="https://websiteoss.ecoflow.com/upload/image/1724987290418/pc-compatible-kv.png"
                    h5="https://websiteoss.ecoflow.com/upload/image/1724988389606/m-compatible-kv.png"
                />
                {/* <ul className="cards">
                    {cards?.map((card: any, k: number) => (
                        <li className="card" key={k}>
                            <div className="card-img">
                                <EfImg pc={card.pc} />
                            </div>
                        </li>
                    ))}
                </ul> */}
            </div>
        </div>
    );
};

export default TheComp;
